import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import _defineProperty from "C:/Users/admin/Desktop/\u7965\u4E91/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapGetters } from 'vuex';
import RelevanceCompany from '@/directive/company/index.js';
export default {
  name: 'Header',
  computed: _objectSpread(_objectSpread({}, mapGetters(['userInfo'])), {}, {
    userName: function userName() {
      var _this$userInfo, _this$userInfo$erpInf, _this$userInfo2;
      return ((_this$userInfo = this.userInfo) === null || _this$userInfo === void 0 ? void 0 : (_this$userInfo$erpInf = _this$userInfo.erpInfoRespVO) === null || _this$userInfo$erpInf === void 0 ? void 0 : _this$userInfo$erpInf.name) || ((_this$userInfo2 = this.userInfo) === null || _this$userInfo2 === void 0 ? void 0 : _this$userInfo2.name);
    }
  }),
  directives: {
    RelevanceCompany: RelevanceCompany
  },
  data: function data() {
    return {};
  },
  methods: {
    handleCommand: function handleCommand(command) {
      if (command === 'logout') {
        this.logout();
      } else if (command === 'updatePassword') {
        this.updatePassword();
      }
    },
    goHome: function goHome() {
      this.$router.replace('/');
    },
    login: function login() {
      this.$router.push('/login');
    },
    logout: function logout() {
      this.$store.dispatch('user/logout');
    },
    updatePassword: function updatePassword() {
      var _this$userInfo3, _this$userInfo3$erpIn;
      if (!((_this$userInfo3 = this.userInfo) !== null && _this$userInfo3 !== void 0 && (_this$userInfo3$erpIn = _this$userInfo3.erpInfoRespVO) !== null && _this$userInfo3$erpIn !== void 0 && _this$userInfo3$erpIn.name)) {
        this.$message.warning('请先关联企业');
        return;
      }
      this.$router.push('/password');
    }
  }
};